import {$api} from "./$api";
import {IPagesTextsResponse} from "./models/IPagesTextsResponse";
import {AxiosResponse} from "axios";
import {UpdatePageTextDto} from "./dto/update-page-text.dto";

export const appApi = {
    getPagesTexts(): Promise<AxiosResponse<IPagesTextsResponse[]>> {
        return $api.get<IPagesTextsResponse[]>('/texts')
    },
    updatePageText(dto: UpdatePageTextDto) {
        return $api.patch('/texts', {...dto})
    }
}